import { TrendingUp } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/business-purchase-sale.jpg";

const PurchaseSaleBusiness = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Business Purchase & Sale Services</h2>
          <p className="text-lg text-muted-foreground">
            Complete legal support for buying or selling a business in Texas. We handle due diligence, contract negotiation, asset vs stock purchases, and closing coordination to protect your interests.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Purchase & Sale of Business" subtitle="Expert M&A Legal Services" icon={<TrendingUp className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default PurchaseSaleBusiness;